module.exports = __webpack_public_path__ + "img/warehouse2.b5c0a262.png";